import { createConfig, http, injected } from "wagmi";
import { fallback } from "viem";
import { bsc, bscTestnet } from "wagmi/chains";
import { appChain, bscRpcUrl, isLocal, isTestnet, localChain } from "./constants";
import { lazyWalletConnect } from "./walletConnectLazy";

const walletConnectProjectId = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID as string | undefined;
// This product supports TokenPocket only. A targeted connector also prevents
// wagmi from restoring a stale MetaMask/Phantom injected session when several
// extensions are installed in the same browser profile.
const connectors = [injected({ shimDisconnect: true, target: "tokenPocket" })];
if (walletConnectProjectId) {
  connectors.push(lazyWalletConnect(walletConnectProjectId) as (typeof connectors)[number]);
}

const testnetRpcUrls = [
  ...(isTestnet ? [bscRpcUrl] : []),
  "https://bsc-testnet-dataseed.bnbchain.org",
  "https://data-seed-prebsc-1-s1.bnbchain.org:8545",
  "https://data-seed-prebsc-2-s1.bnbchain.org:8545"
];

const mainnetRpcUrls = [
  ...(!isTestnet ? [bscRpcUrl] : []),
  "https://bsc-dataseed.bnbchain.org",
  "https://bsc-dataseed1.bnbchain.org",
  "https://bsc-dataseed2.bnbchain.org",
  "https://bsc-dataseed3.bnbchain.org"
];

function createRpcTransport(urls: string[]) {
  return fallback(
    [...new Set(urls)].map((url) => http(url, { retryCount: 2, timeout: 8_000 }))
  );
}

const configuredChains = isLocal
  ? ([localChain] as const)
  : isTestnet
  ? ([bscTestnet, bsc] as const)
  : ([bsc, bscTestnet] as const);

export const wagmiConfig = createConfig({
  chains: configuredChains,
  connectors,
  transports: {
    [appChain.id]: http(bscRpcUrl),
    [localChain.id]: http(bscRpcUrl),
    [bsc.id]: createRpcTransport(mainnetRpcUrls),
    [bscTestnet.id]: createRpcTransport(testnetRpcUrls)
  }
});
